/**
 * @module app.bdc.reports.sepaBuralodCtrl
 *
 */
define(['angular', 'moment', 'modules/bdc/reports/controllers/sepaCtrl'], function(angular) {


    function SepaBuralogCtrl($scope, $window, $rootScope, SepaCtrl) {
        SepaCtrl($scope, $window, $rootScope, 'BURALOG');
    }

    SepaBuralogCtrl.$inject = ['$scope', '$window', '$rootScope', 'SepaCtrl'];

    angular
        .module('app.bdc.reports.sepaBuralogCtrl', ['app.bdc.reports.sepaCtrl'])
        .controller('SepaBuralogCtrl', SepaBuralogCtrl);
});
